// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/frontend/stylesheets/error.sass
// module id = 203
// module chunks = 0